import { Entry, useContent } from '@parcel2go/npm-p2g-app';
import { useMemo } from 'react';

export function useRawCmsContent(contentKey: string) {
  const { state } = useContent();

  const content = useMemo(() => {
    const c = (state.data as Entry<{ value: string; id: string; name: string }>[] | undefined)?.find(
      (item) => (item.fields?.id === contentKey || item.fields?.name === contentKey) && item.fields?.value
    );
    return c?.fields?.value || null;
  }, [contentKey, state.data]);

  return content;
}
